import React, { useMemo } from 'react';
import { Layout, Menu, Dropdown, Avatar } from 'antd';
import { useNavigate, Outlet } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const { Header, Content, Footer, Sider } = Layout;

const AdminMainLayout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem('user')) || { name: 'Guest', email: '', role: 'Viewer' };

  // ✅ Role'e göre menü öğelerini filtrele
  const menuItems = useMemo(() => {
    const baseItems = [
      { key: '14', label: t('admin_dashboard'), roles: ['SuperAdmin', 'Admin', 'Viewer'] },
      { key: '20', label: t('supplier_view'), roles: ['SuperAdmin', 'Admin', 'Viewer'] },
      { key: '19', label: t('supplier_control'), roles: ['SuperAdmin', 'Admin'] },
      { key: '15', label: t('certificate_view'), roles: ['SuperAdmin', 'Admin', 'Viewer'] },
      { key: '21', label: t('role_assignment'), roles: ['SuperAdmin'] },
      { key: '22', label: t('performance_data_entry'), roles: ['SuperAdmin', 'Admin'] },
      { key: '23', label: t('performance_data_list'), roles: ['SuperAdmin', 'Admin', 'Viewer'] },
      { key: '24', label: t('contact_type_management'), roles: ['SuperAdmin'] },
    ];

    // ✅ Kullanıcının rolüne göre filtrele
    const filteredItems = baseItems.filter(item => item.roles.includes(user.role));

    return [
      {
        key: 'grp',
        label: t('supplier_portal_dashboard'),
        type: 'group',
        children: filteredItems,
      },
    ];
  }, [user.role, t]);

  const onClick = (e) => {
    const routes = {
      '14': '/admin-dashboard',
      '15': '/admin-dashboard/certificate-view',
      '19': '/admin-dashboard/supplier-control',
      '20': '/admin-dashboard/supplier-view-page',
      '21': '/admin-dashboard/role-assignment',
      '22': '/admin-dashboard/performance-data-entry',
      '23': '/admin-dashboard/performance-data-list',
      '24': '/admin-dashboard/contact-type-management',
    };
    
    if (routes[e.key]) {
      navigate(routes[e.key]);
    }
  };

  const menu = (
    <Menu
      items={[
        {
          key: '1',
          label: (
            <div>
              <strong>{user.supplierName || user.name}</strong>
              <br />
              <span style={{ fontSize: '12px', color: 'gray' }}>{user.email}</span>
              <br />
              <span style={{ fontSize: '11px', color: 'blue' }}>Role: {user.role}</span>
            </div>
          ),
        },
        {
          key: '2',
          label: t('exit'),
          onClick: () => {
            localStorage.clear();
            navigate('/');
          },
        },
      ]}
    />
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        height: '90px',
        background: '#001529',
        padding: '0 30px',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <img
          style={{ width: '200px', cursor: 'pointer' }}
          src='https://daiichi.com/new_site/wp-content/uploads/2019/11/daiichi-logo-w.svg'
          alt='Logo'
          onClick={() => navigate('/admin-dashboard')}
        />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}>
            <LanguageSwitcher />
          </div>

          <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <Avatar size="large" icon={<UserOutlined />} style={{ marginRight: '10px' }} />
              <div style={{ display: 'flex', flexDirection: 'column', color: '#fff' }}>
                <span style={{ fontWeight: 'bold' }}>{user.name}</span>
                <span style={{ fontSize: '12px', color: '#d9d9d9' }}>{user.email}</span>
              </div>
            </div>
          </Dropdown>
        </div>
      </Header>

      <Layout>
        <Sider width={256} style={{ background: '#fff' }}>
          <Menu
            onClick={onClick}
            style={{ height: '100%' }}
            defaultSelectedKeys={['14']}
            mode="inline"
            items={menuItems}
          />
        </Sider>

        <Content style={{ margin: '0 16px' }}>
          <Outlet />
        </Content>
      </Layout>

      <Footer style={{ textAlign: 'center' }}>
        {t('footer')}
      </Footer>
    </Layout>
  );
};

export default AdminMainLayout;
